import { Type } from 'class-transformer';
import { IsDefined, IsNotEmpty, ValidateNested } from 'class-validator';
import { IsMongoIdObject } from '../../../decorators/is-mongo-object-id.decorator';
import { UserRegistrationId } from '../../../types';
import { UserRegistrationIdentityDto } from '../user-registration-identity.dto';

export class UserRegistrationCreatedByPopulateDto {
  @ValidateNested()
  @Type(() => UserRegistrationIdentityDto)
  @IsDefined()
  identity!: UserRegistrationIdentityDto;

  @IsMongoIdObject()
  @IsNotEmpty()
  _id!: UserRegistrationId;
}
